import { useQueries, useQueryClient } from "@tanstack/react-query";

import { getFarmFootprintByYearAdmin } from "services";

import { getActiveToken, useGetCarbonProgramByFarmId } from "utils";

import { FOOTPRINTING_FARM } from "consts";

export const useGetFootprintingFarmFootprintsAdmin = (farmId?: string, years: number[] = [], { enabled = true } = {}) => {
  const queryClient = useQueryClient();
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);
  const token = getActiveToken();

  return useQueries({
    queries: years.map((year) => ({
      queryKey: [FOOTPRINTING_FARM, farmId, year],
      queryFn: () => getFarmFootprintByYearAdmin(farmId ?? "", year),
      enabled: enabled && carbonProgram?.platformFeatures?.footprinting?.enabled && !!farmId && !!year && !!token, // only fetch if user is logged in + extra conditions met
      queryClient,
      gcTime: 60000,
    })),
  });
};
